import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.JD2pwH',
    defaultMessage: 'Organizations',
  },
  description: {
    id: 'studio.rgudrj',
    defaultMessage: 'Browse the different organizations who are using Appsemble',
  },
  PublishBlocks: {
    id: 'studio.Z8Fm9O',
    defaultMessage: 'The permission to publish blocks for an organization.',
  },
  DeleteBlocks: {
    id: 'studio.sMvj26',
    defaultMessage: 'The permission to delete blocks for an organization.',
  },
  CreateApps: {
    id: 'studio.FNNM8q',
    defaultMessage: 'The permission to create apps in an organization.',
  },
  QueryApps: {
    id: 'studio.uzN4CO',
    defaultMessage: 'The permission to view private apps of an organization.',
  },
  UpdateApps: {
    id: 'studio.5mGXnp',
    defaultMessage: 'The permission to update apps in an organization.',
  },
  DeleteApps: {
    id: 'studio.lCKQlO',
    defaultMessage: 'The permission to delete apps in an organization.',
  },
  QueryAppMessages: {
    id: 'studio.Ld4hwc',
    defaultMessage: 'The permission to query app translations.',
  },
  CreateAppMessages: {
    id: 'studio.g7HwgE',
    defaultMessage: 'The permission to create app translations.',
  },
  UpdateAppMessages: {
    id: 'studio.4NDcCC',
    defaultMessage: 'The permission to update app translations.',
  },
  DeleteAppMessages: {
    id: 'studio.6Ev9Ll',
    defaultMessage: 'The permission to delete app translations.',
  },
  ReadAppSettings: {
    id: 'studio.fQLSXx',
    defaultMessage: 'The permission to read app settings.',
  },
  UpdateAppSettings: {
    id: 'studio.bthoYl',
    defaultMessage: 'The permission to update app settings.',
  },
  CreateAppScreenshots: {
    id: 'studio.RCOsOL',
    defaultMessage: 'The permission to create app screenshots.',
  },
  DeleteAppScreenshots: {
    id: 'studio.nS1qCT',
    defaultMessage: 'The permission to delete app screenshots.',
  },
  CreateAppReadmes: {
    id: 'studio.GJO0Ao',
    defaultMessage: 'The permission to create app readmes.',
  },
  DeleteAppReadmes: {
    id: 'studio.76J8Yx',
    defaultMessage: 'The permission to delete app readmes.',
  },
  CreateAppSecrets: {
    id: 'studio.vqCIsd',
    defaultMessage: 'The permission to create app secrets.',
  },
  QueryAppSecrets: {
    id: 'studio.RcZRz+',
    defaultMessage: 'The permission to query app secrets.',
  },
  UpdateAppSecrets: {
    id: 'studio.BG373v',
    defaultMessage: 'The permission to update app secrets.',
  },
  DeleteAppSecrets: {
    id: 'studio.6spWOs',
    defaultMessage: 'The permission to delete app secrets.',
  },
  QueryAppVariables: {
    id: 'studio.+xONLL',
    defaultMessage: 'The permission to query app variables.',
  },
  CreateAppVariables: {
    id: 'studio.MQ17NC',
    defaultMessage: 'The permission to create app variables.',
  },
  UpdateAppVariables: {
    id: 'studio.PEMz2L',
    defaultMessage: 'The permission to update app variables.',
  },
  DeleteAppVariables: {
    id: 'studio.9Z805R',
    defaultMessage: 'The permission to delete app variables.',
  },
  CreateAppResources: {
    id: 'studio.BPiNPW',
    defaultMessage: 'The permission to create app resources.',
  },
  QueryAppResources: {
    id: 'studio.rjAlQ4',
    defaultMessage: 'The permission to query app resources.',
  },
  GetAppResources: {
    id: 'studio.+Fvztk',
    defaultMessage: 'The permission to get app resources.',
  },
  GetAppResourceHistory: {
    id: 'studio.fbd33j',
    defaultMessage: 'The permission to get the app resource history',
  },
  UpdateAppResources: {
    id: 'studio.zR3D4p',
    defaultMessage: 'The permission to update app resources.',
  },
  PatchAppResources: {
    id: 'studio.ZRF/CV',
    defaultMessage: 'The permission to patch app resources.',
  },
  DeleteAppResources: {
    id: 'studio.zHUl3w',
    defaultMessage: 'The permission to delete app resources.',
  },
  CreateAppAssets: {
    id: 'studio.+xp9k4',
    defaultMessage: 'The permission to create app assets.',
  },
  QueryAppAssets: {
    id: 'studio.HezXr1',
    defaultMessage: 'The permission to query app assets.',
  },
  UpdateAppAssets: {
    id: 'studio.cvsZgz',
    defaultMessage: 'The permission to update app assets.',
  },
  DeleteAppAssets: {
    id: 'studio.QQcj9y',
    defaultMessage: 'The permission to delete app assets.',
  },
  UpdateOrganizations: {
    id: 'studio./uHCud',
    defaultMessage: 'The permission to update organizations.',
  },
  DeleteOrganizations: {
    id: 'studio.kfTLvf',
    defaultMessage: 'The permission to delete organizations.',
  },
  CreateOrganizationInvites: {
    id: 'studio.me/6nr',
    defaultMessage: 'The permission to create organization invites.',
  },
  QueryOrganizationInvites: {
    id: 'studio.zeLyJL',
    defaultMessage: 'The permission to query organization invites.',
  },
  UpdateOrganizationInvites: {
    id: 'studio.O/xXEL',
    defaultMessage: 'The permission to update organization invites.',
  },
  DeleteOrganizationInvites: {
    id: 'studio.gUZ9Rb',
    defaultMessage: 'The permission to delete organization invites.',
  },
  QueryOrganizationMembers: {
    id: 'studio.BzTzOo',
    defaultMessage: 'The permission to view the list of members in an organization.',
  },
  RemoveOrganizationMembers: {
    id: 'studio./BTTpN',
    defaultMessage: 'The permission to remove organization members.',
  },
  UpdateOrganizationMemberRoles: {
    id: 'studio.o+nqjA',
    defaultMessage: 'The permission to change the roles of organization members.',
  },
  CreateAppInvites: {
    id: 'studio.32vEnD',
    defaultMessage: 'The permission to create app invites.',
  },
  QueryAppInvites: {
    id: 'studio.yMyg2P',
    defaultMessage: 'The permission to query app invites.',
  },
  DeleteAppInvites: {
    id: 'studio.Jrk0SZ',
    defaultMessage: 'The permission to delete app invites.',
  },
  QueryAppMembers: {
    id: 'studio.DZWIKx',
    defaultMessage: 'The permission to query app members.',
  },
  DeleteAppMembers: {
    id: 'studio.VWyf7F',
    defaultMessage: 'The permission to delete app members.',
  },
  UpdateAppMemberRoles: {
    id: 'studio.huHOtm',
    defaultMessage: 'The permission to update the role of app members.',
  },
  PatchAppMemberProperties: {
    id: 'studio.nbL8T0',
    defaultMessage: 'The permission to patch the properties of app members.',
  },
  QueryGroups: {
    id: 'studio.cGDbtk',
    defaultMessage: 'The permission to query app groups.',
  },
  CreateGroups: {
    id: 'studio.1d0Fca',
    defaultMessage: 'The permission to create app groups.',
  },
  UpdateGroups: {
    id: 'studio.2TrzH5',
    defaultMessage: 'The permission to update app groups.',
  },
  DeleteGroups: {
    id: 'studio.4owxuc',
    defaultMessage: 'The permission to delete app groups.',
  },
  CreateGroupInvites: {
    id: 'studio.utlWEf',
    defaultMessage: 'The permission to create group invites.',
  },
  QueryGroupInvites: {
    id: 'studio.e1uw1Q',
    defaultMessage: 'The permission to query group invites.',
  },
  DeleteGroupInvites: {
    id: 'studio.ErwI1g',
    defaultMessage: 'The permission to delete group invites.',
  },
  QueryGroupMembers: {
    id: 'studio.YB73Dp',
    defaultMessage: 'The permission to query group members.',
  },
  RemoveGroupMembers: {
    id: 'studio.FUKP1D',
    defaultMessage: 'The permission to remove group members.',
  },
  CreateGroupMembers: {
    id: 'studio.wprTdD',
    defaultMessage: 'The permission to add app members to groups',
  },
  UpdateGroupMemberRoles: {
    id: 'studio.VYTzq3',
    defaultMessage: 'The permission to update group member roles.',
  },
  QueryAppSnapshots: {
    id: 'studio.LbII3k',
    defaultMessage: 'The permission to query app snapshots.',
  },
  CreateAppCollections: {
    id: 'studio.UBNfTT',
    defaultMessage: 'The permission to create app collections.',
  },
  DeleteAppCollections: {
    id: 'studio.9TomUe',
    defaultMessage: 'The permission to delete app collections.',
  },
  UpdateAppCollections: {
    id: 'studio.JBnV+S',
    defaultMessage: 'The permission to update app collections.',
  },
  PushAppNotifications: {
    id: 'studio.+7+1T0',
    defaultMessage: 'The permission to send manual push notifications for an app.',
  },
  ManageOrganizationSubscriptions: {
    id: 'studio.7MEwoZ',
    defaultMessage: 'The permission to manage subscriptions.',
  },
  QueryOrganizationSubscriptions: {
    id: 'studio.wui5o0',
    defaultMessage: 'The permission to view subscriptions.',
  },
  InvokeAppWebhooks: {
    id: 'studio.9CzlTo',
    defaultMessage: 'The permission to invoke app webhooks.',
  },
});
